/*
 * SrZoom — «Приближение» в готовой записи экрана (26.10.2026): плавный наезд на
 * место, удержание, отъезд; два места подряд — панорама от одного к другому без
 * отъезда на весь кадр. Чистая математика, общая для превью (CSS-трансформ
 * плеера) и экспорта (WebCodecsPipeline geometry2d) — одна функция пути,
 * поэтому то, что человек видел в превью, и есть файл.
 *
 * Отрезок: {t0, t1, rect:{x,y,w,h}} — время в секундах, область ДОЛЯМИ кадра
 * (как SrRegion). Область всегда в пропорциях кадра: приближение не растягивает
 * картинку (fit() её доводит).
 *
 *   SrZoom.fit(rect)              → область в пропорции кадра (w === h в долях), внутри кадра
 *   SrZoom.clean(segs, dur)       → отсортированные, внутри [0,dur], без наложений
 *   SrZoom.viewAt(segs, t, o)     → {x,y,w,h} — что из кадра показать в момент t
 *       o.ramp — длительность наезда/отъезда, с (0.6)
 *
 * Наезд идёт по «пространству приближения»: центр — линейно, масштаб —
 * логарифмически, со сглаживанием smootherstep (скорость 0 на концах): ×2 и
 * ×4 воспринимаются одинаково быстрыми, камера не «дёргается» на старте.
 *
 * Тест — tests/js/screen-recorder-zoom.test.mjs.
 */
(function (root) {
    'use strict';

    var FULL = { x: 0, y: 0, w: 1, h: 1 };
    var MIN_W = 0.12;          // сильнее ×8 — уже не «приближение», а пиксели
    var MIN_LEN = 0.5;         // отрезок короче — промах по шкале

    function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
    function num(v) { return typeof v === 'number' && isFinite(v); }
    function smoother(u) { u = clamp(u, 0, 1); return u * u * u * (u * (u * 6 - 15) + 10); }

    // Область в пропорции кадра. В долях кадра пропорция области равна
    // пропорции кадра, когда w === h (доли!) — значит, достаточно одной стороны.
    function fit(r) {
        if (!r || !num(r.x) || !num(r.y) || !num(r.w) || !num(r.h)) return { x: 0, y: 0, w: 1, h: 1 };
        var cx = r.x + r.w / 2, cy = r.y + r.h / 2;
        // какая сторона задаёт масштаб: та, что «шире» в пикселях кадра
        var s = Math.max(r.w, r.h);
        s = clamp(s, MIN_W, 1);
        var x = clamp(cx - s / 2, 0, 1 - s), y = clamp(cy - s / 2, 0, 1 - s);
        return { x: x, y: y, w: s, h: s };
    }

    function clean(segs, dur) {
        var D = num(dur) && dur > 0 ? dur : Infinity;
        var out = (segs || []).filter(function (s) { return s && num(s.t0) && num(s.t1) && s.rect; })
            .map(function (s) { return { t0: clamp(Math.min(s.t0, s.t1), 0, D), t1: clamp(Math.max(s.t0, s.t1), 0, D), rect: fit(s.rect) }; })
            .filter(function (s) { return s.t1 - s.t0 >= MIN_LEN; })
            .sort(function (a, b) { return a.t0 - b.t0; });
        // наложение: позднее начинается, когда кончилось раннее
        for (var i = 1; i < out.length; i++) {
            if (out[i].t0 < out[i - 1].t1) out[i].t0 = out[i - 1].t1;
        }
        return out.filter(function (s) { return s.t1 - s.t0 >= MIN_LEN; });
    }

    function lerp(a, b, u) { return a + (b - a) * u; }
    // Между двумя областями: центр линейно, размер — логарифмически.
    function between(A, B, u) {
        var e = smoother(u);
        var ca = { x: A.x + A.w / 2, y: A.y + A.h / 2 }, cb = { x: B.x + B.w / 2, y: B.y + B.h / 2 };
        var w = Math.exp(lerp(Math.log(A.w), Math.log(B.w), e));
        var cx = lerp(ca.x, cb.x, e), cy = lerp(ca.y, cb.y, e);
        var x = clamp(cx - w / 2, 0, 1 - w), y = clamp(cy - w / 2, 0, 1 - w);
        return { x: x, y: y, w: w, h: w };
    }

    // A gap shorter than this between two places is no room for a pan: the pan
    // runs over the first `ramp` of the next place instead (no cut).
    var MIN_PAN = 0.25;
    function viewAt(segs, t, o) {
        var ramp = (o && num(o.ramp) && o.ramp > 0) ? o.ramp : 0.6;
        if (!segs || !segs.length) return FULL;
        for (var i = 0; i < segs.length; i++) {
            var s = segs[i], prev = segs[i - 1] || null, next = segs[i + 1] || null;
            var r = Math.min(ramp, (s.t1 - s.t0) / 2);
            var gapIn = prev ? s.t0 - prev.t1 : Infinity, gapOut = next ? next.t0 - s.t1 : Infinity;
            var nearIn = gapIn < 2 * ramp, nearOut = gapOut < 2 * ramp;
            if (t >= s.t0 && t <= s.t1) {
                if (t < s.t0 + r) {
                    if (!nearIn) return between(FULL, s.rect, (t - s.t0) / r);           // zoom in
                    if (gapIn < MIN_PAN) return between(prev.rect, s.rect, (t - s.t0) / r); // pan inside
                }
                if (!nearOut && t > s.t1 - r) return between(s.rect, FULL, (t - (s.t1 - r)) / r);   // zoom out
                return { x: s.rect.x, y: s.rect.y, w: s.rect.w, h: s.rect.h };
            }
            if (nearOut && t > s.t1 && t < next.t0) {
                // the pan runs in the gap when there is room, else at the next start
                if (gapOut >= MIN_PAN) return between(s.rect, next.rect, (t - s.t1) / gapOut);
                return { x: s.rect.x, y: s.rect.y, w: s.rect.w, h: s.rect.h };
            }
        }
        return FULL;
    }

    root.SrZoom = { fit: fit, clean: clean, viewAt: viewAt, FULL: FULL, MIN_LEN: MIN_LEN };
})(typeof window !== 'undefined' ? window : globalThis);
